{
  "expo": {
    "name": "TapNPark",
    "slug": "ipctg-park-app",
    "version": "1.0.0",
    "orientation": "portrait",
    "icon": "./assets/images/icon.png",
    "scheme": "tapnpark",
    "userInterfaceStyle": "automatic",
    "newArchEnabled": true,
    "ios": {
      "config": {
        "usesNonExemptEncryption": false
      },
      "infoPlist": {
        "NSLocationWhenInUseUsageDescription": "This app needs to access your location."
      },
      "requireFullScreen": true,
      "supportsTablet": true,
      "bundleIdentifier": "ipctg.tapnparkapp"
    },
    "android": {
      "adaptiveIcon": {
        "foregroundImage": "./assets/images/adaptive-icon.png",
        "backgroundColor": "#FFC817"
      },
      "package": "ipctg.tapnparkapp"
    },
    "web": {
      "bundler": "metro",
      "backgroundColor": "#FFC817",
      "favicon": "./assets/images/favicon.png",
      "output": "single"
    },
    "plugins": [
      [
        "expo-camera",
        {
          "recordAudioAndroid": false
        }
      ],
      [
        "expo-font",
        {
          "fonts": [
            "node_modules/@expo-google-fonts/inter/Inter_100Thin.ttf",
            "node_modules/@expo-google-fonts/inter/Inter_200ExtraLight.ttf",
            "node_modules/@expo-google-fonts/inter/Inter_300Light.ttf",
            "node_modules/@expo-google-fonts/inter/Inter_400Regular.ttf",
            "node_modules/@expo-google-fonts/inter/Inter_500Medium.ttf",
            "node_modules/@expo-google-fonts/inter/Inter_600SemiBold.ttf",
            "node_modules/@expo-google-fonts/inter/Inter_700Bold.ttf",
            "node_modules/@expo-google-fonts/inter/Inter_800ExtraBold.ttf",
            "node_modules/@expo-google-fonts/inter/Inter_900Black.ttf"
          ]
        }
      ],
      "expo-router",
      [
        "expo-screen-orientation",
        {
          "initialOrientation": "PORTRAIT_UP"
        }
      ],
      [
        "expo-secure-store",
        {
          "configureAndroidBackup": true,
          "faceIDPermission": "Allow $(PRODUCT_NAME) to access your Face ID biometric data."
        }
      ],
      [
        "expo-splash-screen",
        {
          "image": "./assets/images/splash-icon.png",
          "imageWidth": 200,
          "resizeMode": "contain",
          "backgroundColor": "#FFC817"
        }
      ],
      [
        "@sentry/react-native/expo",
        {
          "organization": "4507692276514816",
          "project": "ipctg-park-app",
          "url": "https://sentry.io/"
        }
      ]
    ],
    "experiments": {
      "typedRoutes": true
    }
  }
}
